//@flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash';
import { Link } from 'react-router-dom'
import moment from 'moment'

import { fetchPages, fetchPage, getPages } from './redux';
import { paleGreen } from '../../styles/colors';

type Props = {}

type State = {}

class Page extends Component<Props, State> {

    componentDidMount() {
        const {fetchPage} = this.props;
        const {params} = this.props.match;

        if (params.slug) {
            fetchPage(params.slug);
        } else {
            fetchPage('home');
        }      
    }

    componentWillReceiveProps(nextProps){

        const {fetchPage,match} = this.props;
        const {params} = nextProps.match;

        if (params.slug != match.params.slug) {
            fetchPage(params.slug);
        }
    }

    render() {
        const {pages} = this.props;
        const {params} = this.props.match;

        let slug = params.slug;
        if(!slug) slug = 'home'

        const page = find(pages, (o) => { return o.slug == slug })

        return (
            <Container>

                {page && (
                    <Content>
                    
                        <Title>{page.title.rendered}</Title>

                        <NavLink to="/pages/home">Home</NavLink>
                        <NavLink to="/pages/about">About</NavLink>

                    </Content>
                )}
                
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    height: 100%;
    background-color: ${rgba('black', 0.035)};
`;

const wrapper = css`
    display: flex;
    margin: 0 24px;
    box-sizing: border-box;
    justify-content: center;
    max-width: 1280px;
    width: 100%;
`;

const Content = styled.div`
    ${wrapper};
    flex: 1;
    display: flex;
    flex-direction: row;
`;


const Title = styled.div`
    color: black;
`



const Wrapper = styled.div`
    ${wrapper};
`;

const NavLink = styled(Link)`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 128px;
    &:first-child {
        border-right: 1px solid #000000;
    }
`


const mapDispatchToProps = dispatch => ({
    fetchPage(slug) {
        dispatch(fetchPage(slug))
    }
})

const mapStateToProps = (state, props) => ({
    pages: getPages(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./client/modules/Page/Page.js